<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-model="visible"
    :title="t('header.avatarSettings')"
    width="400"
    @closed="handleClosed"
  >
    <el-upload
      class="avatar-uploader"
      :show-file-list="false"
      :action="url"
      :headers="imageupload()"
      :on-success="handleAvatarSuccess"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="visible = false">{{ t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleUploadHead">
          {{ t('common.confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { imageUrlAndToken } from "@/utils/common"
import { imageupload, getUrl2 } from "@/lib/Form/config/uploadConfig"
import { Plus } from "@element-plus/icons-vue"
import { useUserStore } from "@/store/common"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const userStore = useUserStore()

const visible = defineModel<boolean>("visible", { default: false })

const url = getUrl2()
const imageUrl = ref("")
const imageData = ref<any>({})

// Seed the preview with the current avatar each time the dialog opens.
watch(visible, (open) => {
  if (open) {
    imageUrl.value = userStore.userInfo.avatar || ""
    imageData.value = {}
  }
})

const handleAvatarSuccess = (res: any) => {
  const { previewUrl } = res!.data
  imageData.value = res.data
  imageUrl.value = imageUrlAndToken(previewUrl)
}

const handleUploadHead = () => {
  // Nothing uploaded this session — close without touching the avatar
  // (avoids wiping a valid avatar on an accidental confirm).
  if (!imageData.value.previewUrl) {
    visible.value = false
    return
  }
  const currentUser = Object.assign({}, userStore.userInfo)
  currentUser.avatar = imageData.value.previewUrl
  userStore.setInfo(currentUser, () => {
    visible.value = false
  })
}

const handleClosed = () => {
  imageUrl.value = ""
  imageData.value = {}
}
</script>

<style>
.avatar-uploader .el-upload {
  min-height: 178px;
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

.avatar-uploader .avatar {
  width: 179px;
}
</style>
